import React, { useState, useEffect } from "react";
import "./Carousel.css";
import leftArrow from "../../../assets/Arrow1000.png"
import rightAroow from "../../../assets/Arrow2000.png"
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";

export const Carousel = ({ data, onItemSelect, page }) => {
  const [slide, setSlide] = useState(0);
  const navigate = useNavigate();

  const nextSlide = () => {
    setSlide((prevSlide) => (prevSlide === data.length - 1 ? 0 : prevSlide + 1));
    if (onItemSelect) {
      onItemSelect(slide, "nextslide");

    }
  };

  const prevSlide = () => {
    setSlide((prevSlide) => (prevSlide === 0 ? data.length - 1 : prevSlide - 1));
    if (onItemSelect) {
      onItemSelect(slide, "nextslide");

    }

  };

  useEffect(() => {
   
    if (onItemSelect) {
      onItemSelect(slide);

    }
  }, []);


  return (
    <div className="carousele z-10">

      <div className="gradient-overlay "></div>

      <img src={leftArrow}
        alt="" onClick={prevSlide}
        className={`arrow z-10 arrow-left  z-20`}
        style={{backgroundColor:"white",borderRadius:"50%",  width: 40,
      height: 40}} />


      {data.map((item, idx) => {
        return (
          <div  className="carouselImg" onClick={() => page === "resource" && onItemSelect(item.id)}>
            <img
              src={item.src}
              alt={item.alt}
              key={idx}
              className={slide === idx ? "slide active z-10  object-cover" : "slide slide-hidden w-auto h-auto  object-contain"}
            // onClick={() => navigate(item.href)}
            />
          </div>
        );
      })}


      <img src={rightAroow} alt="" onClick={nextSlide}
        className={`arrow z-20 arrow-right `}
        style={{backgroundColor:"white",borderRadius:"50%",  width: 40,
      height: 40}} />

      <span className="indicators z-20">
        {data.map((_, idx) => {
          return (
            <button
              key={idx}
              className={
                slide === idx ? "indicator active" : "indicator indicator-inactive"
              }
              onClick={() => setSlide(idx)}
            ></button>
          );
        })}
      </span>
<div style={{display:"flex",flexDirection:"column"}}>
  <Typography  variant="h2" sx={{marginBottom:"20px",fontWeigh:"900",color:"white"}}>Whitepapers</Typography>
      <Typography sx={{fontSize:"20px",color:"white",textAlign:"left",paddingLeft:"30px",fontWeight:"600"}}>       Explore in-depth insights, strategies, and best practices tailored for your business. 
        Our comprehensive whitepapers provide valuable knowledge to help you make informed decisions 
        and stay ahead in your industry.</Typography>
</div>
    </div >
  );
};